import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CasiProjectLabel, CasiStoryStatus, CasiStoryType, IProjectFromWeb } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiProjectLabelService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(projectId: number): void {
    this.fetch(projectId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(projectId: number): Observable<CasiProjectLabel[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/projectlabel/byproject/${projectId}`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => CasiProjectLabel.create(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjectLabelService extends CasiProjectLabelService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('projectlabel', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`projectlabel/${id}`, 'getById');
  }

  getByProjectId(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`projectlabel/byproject/${id}`, 'getByProjectId');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('projectlabel', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`projectlabel/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`projectlabel/${id}`, 'destroy');
  }
}
